import {HttpErrorResponse, HttpEvent, HttpHandler, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {BehaviorSubject, catchError, filter, Observable, switchMap, take, tap, throwError} from 'rxjs';
import {inject} from '@angular/core';
import {TokenService} from '../../services/token.service';
import {environment} from '../../../environments/environment';
import {SessionStorageService} from 'ngx-webstorage';
import {TokenInterface} from '../../interfaces/token.interface';

export function requestBuildInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {


  const authToken = inject(SessionStorageService).retrieve('token');
  const mirandaToken = inject(SessionStorageService).retrieve('mirandaToken');
  const userType = inject(SessionStorageService).retrieve('userType');
  const tokenService = inject(TokenService);
  const sessionStorageService = inject(SessionStorageService);
  if(req.url.includes('mirandaHttp')) {
    const request = req.clone({
      url: `${req.url.replace('mirandaHttp', environment.mirandaHttp)}`,
      headers: req.headers
        .set('Authorization', 'Bearer ' + mirandaToken)
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('Accept-Language', 'uk')
    });
    return next(request);
  } else if (req.url.includes('octobus')) {
    const request = req.clone({
      url: `${req.url.replace('octobus', userType === 'driver' ? environment.driverMirandaHttp : userType === 'dispatcher' ? environment.dispatcherMirandaHttp : environment.passengerMirandaHttp)}`,
      headers: req.headers
        .set('Authorization', 'Bearer ' + mirandaToken)
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('Accept-Language', 'uk')
    });
    return next(request);
  }  else if (req.url.includes('cdnHttp')) {
    const request = req.clone({
      url: `${req.url.replace('cdnHttp', environment.cdnHttp)}`,
      headers: req.headers
        .set('Authorization', 'Bearer ' + authToken?.token)
        .set('Content-Type', 'multipart/form-data; charset=utf-8;')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
        .set('Access-Control-Allow-Headers', 'Content-Type, Authorization')
        .set('Access-Control-Allow-Credentials', 'true')
        .set('Accept-Language', 'uk')
    });
    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !tokenService.isRefreshing) {
          return handle401Error(request, next);
        } else if (error.status === 401 && tokenService.isRefreshing) {
          return waitForTokenRefresh(request, next);
        } else {
          return throwError(() => error);
        }
      })
    );
  } else if (req.url.includes('translations')) {
    const request = req.clone({
      url: req.url,
      headers: req.headers
        .set('Content-Type', 'multipart/form-data; charset=utf-8;')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
        .set('Access-Control-Allow-Headers', 'Content-Type, Authorization')
        .set('Access-Control-Allow-Credentials', 'true')
        .set('Accept-Language', 'uk')
    });
    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
      })
    );
  } else {
    const request = req.clone({
      url: `${req.url.replace('suppi', environment.supportHttp)}`,
      headers: req.headers
        .set('Authorization', 'Bearer ' + authToken?.token)
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
        .set('Access-Control-Allow-Headers', 'Content-Type, Authorization')
        .set('Access-Control-Allow-Credentials', 'true')
        .set('Accept-Language', 'uk')
    });
    return next(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !tokenService.isRefreshing) {
          return handle401Error(request, next);
        } else if (error.status === 401 && tokenService.isRefreshing) {
          return waitForTokenRefresh(request, next);
        } else {
          return throwError(() => error);
        }
      })
    );
  }


function handle401Error(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    tokenService.isRefreshing = true;

    return tokenService.refreshOctobusToken(sessionStorageService.retrieve('token')).pipe(
      tap((newTokens) => {
        sessionStorageService.store('token', newTokens);
        tokenService.refreshTokenSubject.next(newTokens);
      }),
      switchMap((newTokens) => {
        return next(addToken(request, newTokens));
      }),
      tap(() => {
        tokenService.isRefreshing = false;
      }),
      catchError((err) => {
        if(err.status === 401) {
          return tokenService.getOctobusToken().pipe(
            tap((newTokens) => {
              sessionStorageService.store('token', newTokens);
              tokenService.refreshTokenSubject.next(newTokens);
              tokenService.isRefreshing = false;
            }),
            switchMap((newTokens) => {
              return next(addToken(request, newTokens));
            }),
            catchError(() => {
              return throwError(() => err);
            })
          )
        } else {
          tokenService.isRefreshing = false;
          tokenService.refreshTokenSubject.next(null);
          return throwError(() => err);
        }
      })
    );
  }

function addToken(request: HttpRequest<any>, token: TokenInterface): HttpRequest<any> {
    if (token) {
      return request.clone({
        setHeaders: { Authorization: `Bearer ${token.token}` },
      });
    }
    return request;
  }

function waitForTokenRefresh(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    return tokenService.refreshTokenSubject.pipe(
      filter((token) => token !== null), // Пропускаємо тільки, коли токен оновлено
      take(1),
      switchMap((token) => {
        return next(addToken(request, token));
      })
    );
  }
}
